export const getSlicedText = (
    text: string,
    sliceStart: number,
    sliceEnd: number,
    sufix?: string,
    prefix?: string
): string => {
    const slicedText = text.slice(sliceStart, sliceEnd);

    if (slicedText.length < text.length) {
        return `${prefix ?? ""}${slicedText}${sufix ?? ""}`;
    }

    return slicedText;
};
